import logo from './logo.svg';
import './App.css';

function Auth() {
  const handleSubmit = e => {
    e.preventDefault();
    const title = document.getElementById('title').value;
    console.log(title);
  }

  return (
    <div>
      <form className="add-form" onSubmit={handleSubmit}>

        <div className="form-control">
          <label>Nhập số điện thoại </label>
          <br />
          <input
            className="border-2 border-rose-600"
            type="text"
            id="title"
            name="age"
            placeholder="Nhập số điện thoại"

          />
        </div>

        <button type='submit'
          className='flex break-inside bg-black rounded-3xl px-8 py-3 mb-3 w-full dark:bg-slate-800 dark:text-white'>
          <div className='flex items-center justify-between flex-1'>
            <span className='text-lg font-medium text-white'>Đăng nhập ngay</span>
            <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
          </div>
        </button>
        <br />



        <div v-if="info" className="block p-6 max-w-sm bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
          <p className="font-normal text-gray-700 dark:text-gray-400">  kết quả .</p>
        </div>
      </form>
      <a href="javascript:history.go(-1)">
        <button className="btn btn-primary" > quay lại </button>
      </a>

      <a href="https://hust.media">
        <button className="btn btn-primary" > Trang chủ </button>
      </a>
    </div>

  );
}

export default Auth;
